import { render, staticRenderFns } from "./subjectApply.vue?vue&type=template&id=83c2da3e&scoped=true&"
import script from "./subjectApply.vue?vue&type=script&lang=js&"
export * from "./subjectApply.vue?vue&type=script&lang=js&"
import style0 from "./subjectApply.vue?vue&type=style&index=0&id=83c2da3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c2da3e",
  null
  
)

export default component.exports